
import {
  computed, defineComponent, PropType,
} from 'vue';
import Dialog from 'primevue/dialog';

type Variant = 'primary' | 'danger';

export default defineComponent({
  name: 'BillingConfirmDialog',

  components: { Dialog },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      default: '',
    },
    confirmLabel: {
      type: String,
      required: true,
    },
    cancelLabel: {
      type: String,
      required: true,
    },
    variant: {
      type: String as PropType<Variant>,
      default: 'primary',
    },
    submitting: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
  },

  emits: ['update:visible', 'confirm', 'cancel'],

  setup(props, { emit }) {
    const iconClass = computed(() => {
      if (props.icon) return props.icon;
      return props.variant === 'danger'
        ? 'fa-regular fa-triangle-exclamation'
        : 'fa-regular fa-circle-question';
    });

    const onConfirm = () => {
      if (props.submitting) return;
      emit('confirm');
    };

    const onCancel = () => {
      if (props.submitting) return;
      emit('cancel');
      emit('update:visible', false);
    };

    const onVisibleChange = (v: boolean) => {
      if (!v && !props.submitting) {
        emit('cancel');
        emit('update:visible', false);
      }
    };

    return {
      iconClass,
      onConfirm,
      onCancel,
      onVisibleChange,
    };
  },
});
